import React, { FC, useCallback, useEffect, useState } from 'react';
import classNames from 'classnames/bind';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import Text from '../../atoms/Text';
import styles from './Card.module.pcss';
import Icon from '../../atoms/Icon';
import properties from '../../../modules/ajio-util/properties';
import { displayValue, calculateDiscount } from '../../utils/priceUtils';
import { config } from './Config';
import Shimmer from './Shimmer';
import PriceRevealPLP from '../../../components/common/ListingPage/priceRevealPLP/PriceRevealPLP';
import { signInCheck } from '../../../components/common/CheckUserStatus';
import {
  loadWishlistOptionCodesAPI,
  addProductToWishlist,
  removeProductFromWishlistPDP
} from '../../../wishlist/actions/wishlist';
import { buildQuery } from '../../../utils/products';
import { gtmEventPush, luxeGtmProductClick, appendItmSourceToURL } from '../../../modules/ga/GTMdatalayer';

import { redirect } from '../../utils/cartUtils';
import { addOrUpdateParameter } from '../../../modules/ajio-util/query';
import { isCatalogNameInFirebaseStore } from '../../../utils/common';
import { getStoresForHidingMRP } from '../../selectors/featureFlagsSelector';
import { replaceWithJioCDN } from '../../../utils/imageHandling';

const cx = classNames.bind(styles);

interface CurrentVideoDetailsType {
  videoName: string;
  video_load_time: number;
  isAutoPlayEnabled: boolean;
}
interface CardPropType {
  priceRevealState: boolean;
  platform: string;
  id: string;
  product: import('../../types/product').Product;
  loading: boolean;
  variant: string;
  wishlistOptionCodeUpdates?: boolean;
  addToWishlistApi(): any;
  removeProductFromWishlistPDP(): any;
  loadWishlistOptionCodesAPI(): any;
  isLuxe: boolean;
  currentStore: string;
  bannerName: string;
  username: string;
  rowNumber: number;
  currentRowIndex: number;
  currentBannerMediaType: string;
  currentVideoDetails: CurrentVideoDetailsType;
  getCurrentScrollPosition(): void;
  storesForHidingMRP?: Array;
}
const validFormats = ['productGrid3ListingImage', 'mobileProductListingImage', 'product'];

const Card: FC<CardPropType> = props => {
  const {
    id,
    platform = 'msite',
    product = {},
    loading,
    priceRevealState,
    variant,
    wishlistOptionCodeUpdates,
    isLuxe,
    currentStore,
    currentBannerMediaType,
    currentVideoDetails,
    storesForHidingMRP
  } = props;
  const {
    inStockFlag,
    name,
    fnlColorVariantData: { brandName, colorGroup } = {},
    price: { value, futureBestPrice = '' } = {},
    wasPriceData: { value: totalValue } = {},
    offerPrice: { value: offerValue, priceReveal = {} } = {},
    images,
    code,
    url,
    brickCategory,
    brickName,
    catalogName,
    segmentId = '',
    experimentId = ''
  } = product;
  const hideMRP = isCatalogNameInFirebaseStore(storesForHidingMRP, catalogName);
  let mainImage;
  images?.forEach(element => {
    if (validFormats.includes(element.format)) {
      mainImage = element.url;
    }
  });

  if (loading) {
    return <Shimmer variant={variant} id={id} />;
  }

  useEffect(() => {
    if (wishlistOptionCodeUpdates) {
      const status = setWishlistStatusFromLocal();
      setisWishListed(status);
    }
  }, [wishlistOptionCodeUpdates]);

  const setWishlistStatusFromLocal = (): boolean => {
    const { product: { fnlColorVariantData: { colorGroup } = {} } = {}, username } = props;
    const wishlistData = JSON.parse(localStorage.getItem('productWishlistStatusData'));

    if (!wishlistData || !username) return false;
    const userWishlistData = wishlistData[username];
    if (!userWishlistData) return false;
    const { codes = [] } = userWishlistData;
    if (codes.length === 0) return false;
    return codes.includes(colorGroup);
  };

  const addWishlistInLocal = (): boolean => {
    const { product: { fnlColorVariantData: { colorGroup } = {} } = {}, username } = props;
    let wishlistData = JSON.parse(localStorage.getItem('productWishlistStatusData'));
    if (!wishlistData || !username) return false;
    const userWishlistData = wishlistData[username];
    if (!userWishlistData) return false;
    const { codes = [], updatedOn } = userWishlistData;
    if (codes.length === 0 || !codes.includes(colorGroup)) codes.push(colorGroup);
    const localData = {
      updatedOn,
      codes
    };
    let finalResponse = wishlistData;
    finalResponse[username] = localData;
    localStorage.setItem('productWishlistStatusData', JSON.stringify(finalResponse));
    return true;
  };

  const [isWishListed, setisWishListed] = useState(() => setWishlistStatusFromLocal());

  const disPrice = displayValue(value);
  const origPrice = displayValue(totalValue);
  const offerPrice = displayValue(offerValue);
  const disPercentage = calculateDiscount(totalValue, value);
  const isOutOfStock = !inStockFlag;
  const offerPriceShow = true;
  // isWishListed = false
  const imageBaseUrl = properties.getProperty('imageBaseUrl');
  const cardConfig = config[platform];
  const containerClass = cx({
    [`${platform}-shopTheLook`]: true,
    'border-radius': cardConfig.isBorderRadius
  });
  const imageRadius = cx({
    'image-radius': cardConfig.isImageBorderRadius && cardConfig.isImageBorderRadius
  });

  useEffect(() => {
    const { addToWishlistApi, loadWishlistOptionCodesAPI, username } = props;
    const prdCode = localStorage.getItem('prdCode');
    if (username) {
      if (prdCode) {
        addToWishlistApi(prdCode);
        localStorage.removeItem('prdCode');
        loadWishlistOptionCodesAPI();
      }
      setGuestUserWishlistStatus();
    }
  }, []);

  const setGuestUserWishlistStatus = () => {
    const { product: { fnlColorVariantData: { colorGroup } = {} } = {} } = props;
    const prdColorGroup = localStorage.getItem('prdColorGroup');
    if (prdColorGroup === colorGroup) {
      setTimeout(() => {
        addWishlistInLocal();
        setisWishListed(true);
        localStorage.removeItem('prdColorGroup');
      }, 500);
    }
  };

  const wishListApiCall = (code: any) => {
    const {
      product: { fnlColorVariantData: { colorGroup } = {} } = {},
      addToWishlistApi,
      bannerName,
      username
    } = props;
    const { location: { href = '', pathname = '', search = '' } = {} } = window;
    if (username) {
      if (isWishListed) {
        removeWishlistAlreadyExists();
        if (currentBannerMediaType === 'IMAGE') {
          gtmEventPush({
            event: 'shop_the_look',
            event_category: 'Shop the Look',
            event_action: 'Remove From wishlist',
            event_label: bannerName,
            prodid: code
          });
        } else {
          gtmEventPush({
            event: 'shop_the_look',
            event_category: 'shop the look video interactions',
            event_action: 'Remove From wishlist',
            event_label: bannerName,
            product_id: code,
            video_name: currentVideoDetails.videoName,
            is_auto_play_enabled: currentVideoDetails.isAutoPlayEnabled,
            video_load_time: currentVideoDetails.video_load_time
          });
        }
        return;
      }
      addToWishlistApi(code);
      addWishlistInLocal();
      setisWishListed(true);
      if (currentBannerMediaType === 'IMAGE') {
        gtmEventPush({
          event: 'shop_the_look',
          event_category: 'Shop the Look',
          event_action: 'Add to wishlist',
          event_label: bannerName,
          prodid: code
        });
      } else {
        gtmEventPush({
          event: 'video_screen_interactions',
          event_category: 'shop the look video interactions',
          event_action: 'add to wishlist',
          product_id: code,
          video_name: currentVideoDetails.videoName,
          is_auto_play_enabled: currentVideoDetails.isAutoPlayEnabled,
          video_load_time: currentVideoDetails.video_load_time,
          page_name: 'shop the look video screen',
          page_type: 'shop the look video screen'
        });
      }
      return;
    }
    localStorage.setItem('prdCode', code);
    localStorage.setItem('prdColorGroup', colorGroup);
    const urlPath = (pathname + search).trim();
    window.location.href = `/login?referrer=${urlPath}`;
  };

  const removeWishlistAlreadyExists = () => {
    const { request = {}, product = {}, location = {} } = props;
    const {
      discountPercent = '',
      price = {},
      fnlColorVariantData: { colorGroup = '' } = {}
    } = product;
    wishListDeleteCall(null, request, colorGroup, price, discountPercent, location, true);
    setisWishListed(false);
  };

  const wishListDeleteCall = (
    e,
    request,
    code,
    price,
    discountPercent,
    location,
    isRemoveFromProductPage = false
  ) => {
    const { removeProductFromWishlistPDP } = props;
    if (e) {
      e.preventDefault();
      e.stopPropagation();
    }
    const reqQuery = { ...request.query };
    reqQuery.currentPage = 0;
    removeItemFromLocal(code);
    removeWishlistInLocal(code);
    const query = buildQuery(reqQuery);
    let nextRequest = { ...request, query };
    removeProductFromWishlistPDP(code, nextRequest);
  };

  const removeItemFromLocal = code => {
    const localData = JSON.parse(localStorage.getItem('wishlistPriceDrop')) || [];
    for (let i = 0; i <= localData?.length - 1; i++) {
      if (localData[i]?.itemCode === code) {
        localData?.splice(i, 1);
      }
    }
    localStorage.setItem('wishlistPriceDrop', JSON.stringify(localData));
  };

  const removeWishlistInLocal = code => {
    const { username } = props;
    let wishlistData = JSON.parse(localStorage.getItem('productWishlistStatusData'));
    if (!wishlistData || !username) return false;
    const userWishlistData = wishlistData[username];
    if (!userWishlistData) return false;
    const { codes = [], updatedOn } = userWishlistData;
    if (codes.length > 0) {
      const index = codes.indexOf(code);
      if (index >= 0) {
        codes.splice(index, 1);
        const localData = {
          updatedOn,
          codes
        };
        let finalResponse = wishlistData;
        finalResponse[username] = localData;
        localStorage.setItem('productWishlistStatusData', JSON.stringify(finalResponse));
      }
    }
  };

  const redirectToPDP = useCallback(() => {
    const { currentRowIndex, rowNumber, getCurrentScrollPosition, platform } = props;
    getCurrentScrollPosition?.();
    const pdpUrl = appendItmSourceToURL(url, {
      itm_source: 'widget',
      itm_source_detail: 'Shop The Look'
    });
    let redirectFn = () => {
      const updateURLParams = addOrUpdateParameter(window.location.href, {
        BannerId: rowNumber,
        currentBannerInRow: currentRowIndex
      });
      window.history.replaceState(null, '', `${updateURLParams}#ShopTheLook`);
      window.location.href = pdpUrl;
    };
    if (currentBannerMediaType === 'IMAGE') {
      luxeGtmProductClick({
        name,
        id: code.length > 9 ? code.substring(0, 9) : code,
        price: disPrice,
        brand: brandName,
        product_color: colorGroup ? colorGroup.split('_')[1] : '',
        product_trade_discount: disPercentage,
        product_brick: brickName,
        list: 'shop the look',
        store_type: currentStore,
        pageType: 'Landing screen',
        pageName: '',
        sourceStore: currentStore,
        containsLuxe: isLuxe,
        pageType: 'shop the look',
        pageName: 'shop the look',
        catalog: catalogName,
        segmentId,
        experimentId
      });
    } else {
      luxeGtmProductClick({
        name,
        id: code.length > 9 ? code.substring(0, 9) : code,
        price: disPrice,
        brand: brandName,
        product_color: colorGroup ? colorGroup.split('_')[1] : '',
        product_trade_discount: disPercentage,
        product_brick: brickName,
        list: 'shop the look video',
        store_type: currentStore,
        pageType: 'Landing screen',
        pageName: '',
        sourceStore: currentStore,
        containsLuxe: isLuxe,
        video_name: currentVideoDetails.videoName,
        video_load_time: currentVideoDetails.video_load_time,
        pageType: 'shop the look video screen',
        pageName: 'shop the look video screen',
        catalog: catalogName,
        segmentId,
        experimentId
      });
    }
    redirectFn();
  }, [url]);

  return (
    <div className={containerClass} key={id}>
      <div className={cx('img-container')} onClick={redirectToPDP}>
        <img src={replaceWithJioCDN(mainImage)} className={imageRadius} />
      </div>
      <div className={cx('details')}>
        <div>
          <Icon
            icon={isWishListed ? 'icon-Wishlist_Active' : 'icon-Wishlist'}
            iconClass={cx('wishlist-icon')}
            styles={{
              color: isWishListed
                ? cardConfig.wishlistIconActiveColor
                : cardConfig.wishlistIconColor
            }}
            onClick={() => wishListApiCall(code)}
          />
          <div className={cx('title')} onClick={redirectToPDP}>
            <Text variant={cardConfig.titleFontSize} weight="bold" color={cardConfig.titleColor}>
              {brandName}
            </Text>
          </div>
          <div className={cx('description')} onClick={redirectToPDP}>
            <Text variant="T2" weight="regular" color={cardConfig.descriptionColor}>
              {name}
            </Text>
          </div>
        </div>
        <div className={cx('price-details')}>
          {isOutOfStock ? (
            <span className={cx('oos-heading')} style={{ background: cardConfig.oosBtnBgColor }}>
              <Text
                variant="T3"
                weight="bold"
                color={cardConfig.oosBtnTextColor}
                textTransform="is-uppercase"
              >
                Out Of Stock
              </Text>
            </span>
          ) : (
            <div className={cx('price')}>
              <Text
                variant={cardConfig.discountPriceFontSize}
                weight={cardConfig.discountPriceFontWeight}
                color={cardConfig.discountPriceColor}
              >
                {disPrice}
              </Text>
              {value !== totalValue && hideMRP ? (
                <Text
                  variant={cardConfig.actualPriceFontSize}
                  weight="regular"
                  color={cardConfig.actualPriceColor}
                  textDecoration="strikethrough"
                >
                  {origPrice}
                </Text>
              ) : null}
              {value !== totalValue && hideMRP ? (
                <Text
                  variant={cardConfig.discountPercentFontSize}
                  weight="bold"
                  color={cardConfig.discountPercentColor}
                >
                  {`${disPercentage}`}
                </Text>
              ) : null}
            </div>
          )}
          {!priceRevealState &&
            offerPriceShow &&
            offerValue &&
            (platform === 'desktop' ? (
              <div className={cx('offer-div')}>
                <span className={cx('offer')}>Offer Price :</span>&nbsp;
                <span className={cx('offer-pricess')}>{offerPrice}</span>
              </div>
            ) : (
              <div className={cx('offer-div-new')}>
                <span>
                  <img
                    src={`${imageBaseUrl}/static/img/percentage.svg`}
                    className={cx('offer-icon')}
                    alt="Offer icon"
                  />
                </span>
                <span className={cx('offer-new')} aria-label="Offer Price">Offer price</span>&nbsp;
                <span className={cx('offer-pricess-new')} aria-label={offerPrice}>{offerPrice}</span>
              </div>
            ))}
          {priceRevealState && (
            <PriceRevealPLP
              deviceType={variant}
              priceReveal={priceReveal}
              orignalPrice={value}
              isShopThelook
              offerValue={offerValue}
              futureBestPrice={futureBestPrice}
            />
          )}
        </div>
      </div>
    </div>
  );
};

const mapDispatchToProps = dispatch => {
  return {
    addToWishlistApi: (productId, showMessage) => {
      dispatch(addProductToWishlist(productId, showMessage));
    },
    removeProductFromWishlistPDP: (productCode, request) =>
      dispatch(removeProductFromWishlistPDP({ data: productCode, request })),
    loadWishlistOptionCodesAPI: () => {
      loadWishlistOptionCodesAPI();
    }
  };
};

const mapStateToProps = (state, ownProps) => {
  const { location = {} } = window;
  const { request = {} } = state;
  return {
    location,
    request,
    storesForHidingMRP: getStoresForHidingMRP(state)
  };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Card));
